import { Component, computed, input, output } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { ConfirmationDialogDirective } from '@xmedical/ui';
import { ProblemDisplayItem, ProblemRemovedEvent } from './problem-widget-view/problem-widget-view.component';
import { hasReferralInfo, formatReferralSource } from '../../types/referral-info';

@Component({
  selector: 'xm-problem-list-view',
  imports: [
    DatePipe,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    MatDividerModule,
    ConfirmationDialogDirective
  ],
  templateUrl: './problem-list-view.component.html',
  styleUrls: ['./problem-list-view.component.scss']
})
export class ProblemListViewComponent {
  items = input<ProblemDisplayItem[]>([]);
  readonly = input<boolean>(true);
  usePrimaryText = input<boolean>(false);
  emptyMessage = input<string>('No problems have been added.');

  itemRemoved = output<ProblemRemovedEvent>();

  hasItems = computed(() => this.items().length > 0);

  onRemoveItem(item: ProblemDisplayItem, index: number): void {
    this.itemRemoved.emit({ item, index });
  }

  isReferred(item: ProblemDisplayItem): boolean {
    return hasReferralInfo(item);
  }

  getReferralText(item: ProblemDisplayItem): string {
    return formatReferralSource(item);
  }
}
